import "@/App.css";
import { useEffect } from "react";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getVisitorId() {
  let id = localStorage.getItem("asa_visitor_id");
  if (!id) {
    id = (crypto?.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random());
    localStorage.setItem("asa_visitor_id", id);
  }
  return id;
}

function App() {
  useEffect(() => {
    // Record a page view for the daily traffic report (fire-and-forget).
    // Skip internal admin visits so analytics reflect real client traffic.
    const path = window.location.pathname || "/";
    if (path.startsWith("/admin")) return;
    axios.post(`${API}/track`, {
      path,
      visitor_id: getVisitorId(),
      referrer: document.referrer || "",
    }).catch(() => {});
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
